<template>
  <v-card class="mt-4">
    <CollapseItems :show="isOnVacation || currentCycleIsFinished">
      <template #title>
        Guia da Revisão
      </template>
      <template #content>
        <div
          v-for="item in module_revision_items"
          :key="item.action_param"
          class="p-3"
        >
          <p>{{ item.text }}</p>
          <v-hover v-slot="{ hover }">
            <v-btn
              :color="hover ? 'theme' : 'nitro'"
              depressed
              class="white--text"
              @click="getModules(item.action_param)"
              v-text="'Acessar o módulo'"
            />
          </v-hover>
        </div>
        <v-dialog
          v-if="showModalModule"
          v-model="showModalModule"
          :fullscreen="$vuetify.breakpoint.mobile"
          :max-width="defaultModalSize"
          :overlay-opacity="DEFAULT_MODAL_OPACITY"
          content-class="no-shadow d-flex justify-content-center align-items-center"
          :overlay-color="DEFAULT_MODAL_OVERLAY_COLOR"
          persistent
        >
          <ModuleContentComponent />
        </v-dialog>
      </template>
    </CollapseItems>
  </v-card>
</template>
<script>

import CollapseItems from "@/common/components/CollapseItems.vue";
import {studyNowRouteName} from "@/student/constants/routes"
import {mapActions, mapGetters, mapState} from "vuex";
import ModuleContentComponent from "./module/content/ModuleContentComponent";
import {DEFAULT_MODAL_OPACITY, DEFAULT_MODAL_OVERLAY_COLOR} from "@/student/constants/general"

export default {
  name: "Revision",
  components: {
    ModuleContentComponent,
    CollapseItems,
  },
  data() {
    return {
      studyNowRouteName,
      DEFAULT_MODAL_OPACITY,
      DEFAULT_MODAL_OVERLAY_COLOR,
      module_revision_items:[
        {
          text: 'Revise aqui o módulo que você mais errou para não esquecer mais.',
          action_param : 'more_wrong_module'

        },
        {
          text: 'Revise aqui o módulo que mais impacta o seu desempenho.',
          action_param : 'more_impact_performance'

        },
        {
          text: 'Que tal olhar novamente o módulo com maior incidência no Enem?',
          action_param : 'higher_incidence_enem'

        },
      ]
    }
  },
  computed: {
    ...mapState({
      defaultModalSize: state => state.defaultModalSize,
      showModalModule: state => state.module.showModalModule,
    }),
    ...mapGetters(['currentCycleIsFinished','isOnVacation']),
  },
  methods: {
    ...mapActions([
      'getModulesForRevision',
      'isLoading',
    ]),

    async getModules(moduleType) {
      this.isLoading();
      await this.getModulesForRevision({moduleType: moduleType});
      this.isLoading(false);
    }
  }
}
</script>
